import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { provideNgxMask } from "ngx-mask";
import { authInterceptor } from './interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    importProvidersFrom(
      MonacoEditorModule.forRoot({
        baseUrl: window.location.origin + "/assets/monaco/min/vs"
        // baseUrl: '/assets/monaco', // configure base path for monaco editor
      })
    ),
    provideNgxMask(),

  ]
};
